export function buildQueryParams(obj) {
  return Object.keys(obj)
    .reduce(function(memo, key) {
      memo.push(key + '=' + encodeURIComponent(obj[key]));
      return memo;
    }, [])
    .join('&');
}



// WEBPACK FOOTER //
// ./src/helpers/buildQueryParams.js